/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_LOADED_MODEL_NAME](state, payload) {
      state.loadedModelName = payload;
  },
  [types.SET_MODEL_BY_SIZE](state, payload) {
      state.modelBySize = payload;
  },
  [types.SAVE_DEFAULT_TEXTURES](state, {componentName, map_type, textureObj}) {
      state.default_textures[componentName] = Object.assign({}, state.default_textures[componentName], {
        [map_type]: textureObj
      });
  }
};

export default mutations;